<script>
  import Layout from '@layout/main'
  import { messageSuccess } from '@utils/message'
  import Update from '@components/Form/Update'

  export default {
    page() {
      return {
        title: `會員設定`,
      }
    },
    components: {
      Layout,
      Update
    },
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      isLIFF() {
        return this.$route.params.lineId ? 'liff' : 'default'
      }
    },
    methods: {},

  }
</script>
<template>
  <Layout :type="isLIFF">
    <BaseBanner
      title="會員資料更新"
      :image="require('@assets/images/memberupdate/banner.png')"
      custom-class="isStyleWhite"
      class="isHasNoFilter"
    />
    <div :class="$style.sectionMemberUpdate">
      <div class="container section">
        <Update
          :default-value="defaultValue"
          class="register"
        />
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" module>
  .sectionMemberUpdate {
    // background: transparent linear-gradient(180deg, rgba(244, 246, 250, 1) 0%, rgba(244, 246, 250, 1) 100%) 0% 0% no-repeat padding-box;
    @include max-md {
      background: transparent;
    }
    :global {
      .register {
        padding: 70px 50px;
        background: #FFF;
        box-shadow: 0 0 8px rgba(33, 69, 88, 0.16);

        @include max-md {
          padding: 0 0 2rem 0;
          box-shadow: none;
          background: transparent;
        }
      }
    }
  }
</style>
